/**
 * Created by Adam on 31/10/2016.
 */
if (window.jQuery) {

    (function ($) {

        const EVENT_NAME_VARIANT_SELECTED = 'variant_selected';
        const EVENT_NAME_VARIANT_VISIBLE = 'variant_visible';
        const RESPONSE_PARAM_TEST_INSTRUCTIONS = 'testInstructions';
        const RESPONSE_PARAM_VARIANT = 'variant';
        const RESPONSE_PARAM_JSON_INSTRUCTION = 'jsonInstruction';
        const RESPONSE_PARAM_TEST_NAME = 'testName';
        const RESPONSE_NULL_VALUE = 'NULL';
        const TRACKING_SEPARATOR = '@';
        const TEST_SERVER_BASE_URL = 'v1/tests/';
        const TEST_SERVER_URL_PARAM = 'url';
        const TEST_QA_TEST_ATTRIBUTE = 'qaTestAttribute';
        const RESPONSE_ERROR_NOT_INCLUDED = 'User is not included in the specified test';
        const RESPONSE_ERROR_CALL_FAILED = 'Error making an AJAX call to test server: ';
        const QUERY_STRING_PARAM_VARIANT_ID = 'variantId';

        window.TCT = window.TCT || {};
        if (window.TCT.Testing) return;

        /**
         * Builds the label of the event to be reported using the variant name and the test name.
         * If given a test data object as first parameter, nothing else is required as everything is in it.
         * Otherwise, both variant and test names are required.
         *
         * @param {object|string} testDataOrTestName
         * @param {string} [variant]
         * @returns {string} The combined test event label
         */
        function buildEventLabel(testDataOrTestName, variant) {
            // support for test data as first parameter
            if (typeof (testDataOrTestName) === 'object' && !!testDataOrTestName['name'] && !!testDataOrTestName['variant']) {
                variant = testDataOrTestName['variant'];
                testDataOrTestName = testDataOrTestName['name'];
            }

            return variant + TRACKING_SEPARATOR + testDataOrTestName;
        }

        /**
         * This function send variant selected tracking.
         * @param {String} testDataOrTestName The test data object (if given variant is disregarded) or the name of the test
         * @param {String} [variant] The variant that selected for the current test
         */
        function trackSelected(testDataOrTestName, variant) {
            var eventName = buildEventLabel(testDataOrTestName, variant);
            trackTest(EVENT_NAME_VARIANT_SELECTED, eventName)
        }

        /**
         * This function send variant visible tracking.
         * @param {String} testDataOrTestName The test data object (if given variant is disregarded) or the name of the test
         * @param {String} [variant] The variant that selected for the current test
         */
        function trackVisible(testDataOrTestName, variant) {
            var eventName = buildEventLabel(testDataOrTestName, variant);
            trackTest(EVENT_NAME_VARIANT_VISIBLE, eventName)
        }

        /**
         * The function get test id,test name and may get location url as parameters, and return the name of the
         * selected variant of the test or null if there isn't one or if the user is not part of the test.
         * It also send the variant selected track if columbus return variant.
         * @param {int|String} testId   The Id (from columbus) of the test.
         * @param {String} [locationUrl]  Location Url of the page for url parameter in the ajax call in case it null it will take location.href as url
         * @returns {String} Return the variant of the test is columbus return null, else it return null.
         */
        function getTestData(testId, locationUrl) {
            if (!testId)
                return null;

            var url = locationUrl || location.href;

            // check if there's a forced attribute in the query string
            var forcedAttributeId = parseInt(getParameterByName(QUERY_STRING_PARAM_VARIANT_ID));
            var forcedAttributeAmendment = '';

            if (forcedAttributeId) {
                // build amendment for API URL
                forcedAttributeAmendment = '&' + TEST_QA_TEST_ATTRIBUTE + '=' + forcedAttributeId;

                // remove query string from the URL that will be sent to API
                var regex = new RegExp('[\\?|\\&]' + QUERY_STRING_PARAM_VARIANT_ID + '=' + forcedAttributeId);
                url = url.replace(regex, '');
            }

            // build API URL
            var apiURL = window['TCTServer']['api'] + TEST_SERVER_BASE_URL + testId + '?' + TEST_SERVER_URL_PARAM + '='
                + encodeURIComponent(url) + forcedAttributeAmendment;

            var d = $.Deferred();

            // Ajax call to columbus
            $.ajax({
                url: apiURL,
                dataType: "json",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true   //we use credentials because we want to pass the cookies and it cross domain call
                },
                //In case the ajax call success it check if there is variant and return it otherwise it return null.
                success: function (response) {

                    var test = response ? response[RESPONSE_PARAM_TEST_INSTRUCTIONS] : null,
                        variant = test ? test[RESPONSE_PARAM_VARIANT] : null,
                        instruction = test ? test[RESPONSE_PARAM_JSON_INSTRUCTION] : null,
                        testName = response ? response[RESPONSE_PARAM_TEST_NAME] : null;

                    if (!!variant && !!testName) {
                        trackSelected(testName, variant);
                    } else {
                        // user is out of the test - no test data to return
                        return d.reject(RESPONSE_ERROR_NOT_INCLUDED);
                    }

                    return d.resolve({
                        id: testId,
                        name: testName,
                        variant: variant,
                        instruction: !instruction || instruction == RESPONSE_NULL_VALUE ? null : instruction
                    });
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    if (jqXHR.status == 200 && textStatus == "parsererror") { // OK but empty
                        return d.reject(RESPONSE_ERROR_NOT_INCLUDED);
                    }
                    return d.reject(RESPONSE_ERROR_CALL_FAILED + errorThrown);
                }
            });

            return d.promise();
        }

        function getParameterByName(name, url) {
            if (!url) {
                url = window.location.href;
            }
            name = name.replace(/[\[\]]/g, "\\$&");
            var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, " "));
        }

        window.TCT.Testing = {
            getTestData: getTestData,
            reportVariantVisible: trackVisible
        };

    })(window.jQuery);
}